import { ActionType, createReducer } from 'typesafe-actions';

import * as actions from './actions';
import { resourcesInitialState } from './initialState';

type State = typeof resourcesInitialState;
type Actions = ActionType<typeof actions>;

export const resourcesReducer = createReducer<State, Actions>(resourcesInitialState)
  .handleAction(actions.actionGetResources, (state) => ({
    ...state,
    loading: state.initLoading,
  }))
  .handleAction(actions.actionSuccessGetResources, (state, action) => ({
    ...state,
    labels: action.payload.resources,
    culture: action.payload.culture,
    loading: false,
    initLoading: false,
  }))
  .handleAction(actions.actionErrorGetResources, (state, action) => ({
    ...state,
    loading: false,
    error: action.payload,
  }))
  .handleAction(actions.actionGetLanguages, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(actions.actionSuccessGetLanguages, (state, action) => ({
    ...state,
    languages: action.payload,
    loading: false,
  }))
  .handleAction(actions.actionErrorGetLanguages, (state, action) => ({
    ...state,
    loading: false,
    error: action.payload,
  }));
